// frontend/src/components/common/fieldLineLabel.js
//
// The id of the enclosing FieldLine's label, for the field it holds. Kept out
// of FieldLine.jsx so that file only exports the React component
// (react-refresh/only-export-components — HMR boundary).

import { createContext, useContext } from 'react';

export const FieldLineLabel = createContext(null);

/** The id of the enclosing FieldLine's label, or null outside one. */
export const useFieldLineLabel = () => useContext(FieldLineLabel);
